import { Container, shadowStandard, XStack, YStack } from '@my/ui'
import { ColumnLayoutBlock } from './column-layout.block'
import { BlockRenderer } from '../block-renderer'
import { BlockToComponentMap } from '../block-mappings'
export interface ColumnLayoutBlockProps extends ColumnLayoutBlock {
  components: BlockToComponentMap
  depth: number
}

export const ColumnLayoutComponent = (props: ColumnLayoutBlockProps) => {
  return (
    <Container bg="$white" py="$6" {...shadowStandard} borderRadius={8}>
      <XStack
        flex={1}
        justifyContent={props.columns.length === 1 ? 'flex-start' : 'space-evenly'}
        columnGap={12}
        alignItems="stretch"
        $gtMd={{
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}
      >
        {props.columns.map((column, index) => (
          <YStack key={`column-${index}`} flex={1} width={`${props.columns.length / 100}%`}>
            <BlockRenderer
              content={column.content}
              additionalComponents={props.components}
              depth={props.depth + 1}
              extraProps={{ isColumnContent: true, numberOfColumns: props.columns.length }}
            />
          </YStack>
        ))}
      </XStack>
    </Container>
  )
}
